import { defineMessages } from 'react-intl';

const messages: {
	moveItemDown: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	moveItemToBottom: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	moveItemToTop: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	moveItemUp: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	newLozenge: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	pinOrgOrUnit: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	reorderItemDropdown: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	showLessSites: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	showMoreSites: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	sites: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	skeleton3pLoaderAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	skeletonLoaderAriaLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	tryLozenge: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unitDescriptionInfoButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	unpinOrgOrUnit: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	newLozenge: {
		id: 'fabric.atlassianSwitcher.newLozenge',
		defaultMessage: 'New',
		description: 'The lozenge text for a lozenge indicating a new switcher item',
	},
	tryLozenge: {
		id: 'fabric.atlassianSwitcher.tryLozenge',
		defaultMessage: 'Try',
		description: 'Alternative lozenge text for a lozenge indicating a new switcher item',
	},
	sites: {
		id: 'fabric.atlassianSwitcher.sites',
		defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
		description: 'The text of a toggle showing or hiding more site options',
	},
	skeletonLoaderAriaLabel: {
		id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
		defaultMessage: 'The App Switcher is loading',
		description: 'The aria-label for the app switcher skeleton loader primitive',
	},
	skeleton3pLoaderAriaLabel: {
		id: 'fabric.atlassianSwitcher.skeleton3pLoaderAriaLabel',
		defaultMessage: 'The App Switcher third party section is loading',
		description: 'The aria-label for the app switcher third party skeleton loader primitive',
	},
	reorderItemDropdown: {
		id: 'fabric.atlassianSwitcher.reorderItemDropdown',
		defaultMessage: 'Reorder menu item',
		description: 'The text of a button to reorder an item in the switcher',
	},
	moveItemUp: {
		id: 'fabric.atlassianSwitcher.moveItemUp',
		defaultMessage: 'Move up',
		description: 'The text of a button to move an item up in the switcher',
	},
	moveItemDown: {
		id: 'fabric.atlassianSwitcher.moveItemDown',
		defaultMessage: 'Move down',
		description: 'The text of a button to move an item down in the switcher',
	},
	moveItemToTop: {
		id: 'fabric.atlassianSwitcher.moveItemToTop',
		defaultMessage: 'Move to top',
		description: 'The text of a button to move an item to the top in the switcher',
	},
	moveItemToBottom: {
		id: 'fabric.atlassianSwitcher.moveItemToBottom',
		defaultMessage: 'Move to bottom',
		description: 'The text of a button to move an item to the bottom in the switcher',
	},
	showMoreSites: {
		id: 'fabric.atlassianSwitcher.showMoreSites',
		defaultMessage: 'Show more',
		description:
			'The text of a button that reveals the remaining sites in an expanded switcher item site list',
	},
	showLessSites: {
		id: 'fabric.atlassianSwitcher.showLessSites',
		defaultMessage: 'Show less',
		description:
			'The text of a button that collapses the expanded list of sites back to the first few in a switcher item',
	},
	unitDescriptionInfoButton: {
		id: 'fabric.atlassianSwitcher.unitDescriptionInfoButton',
		defaultMessage: 'About {unitName}',
		description:
			'The accessible label of an info icon button that reveals a short administrator-written description of the named organisation unit',
	},
	pinOrgOrUnit: {
		id: 'fabric.atlassianSwitcher.pinOrgOrUnit',
		defaultMessage: 'Pin {name}',
		description:
			'Accessible label and tooltip for the button that pins an organisation or unit to the top of the app switcher org list. {name} is the organisation or unit name.',
	},
	unpinOrgOrUnit: {
		id: 'fabric.atlassianSwitcher.unpinOrgOrUnit',
		defaultMessage: 'Unpin {name}',
		description:
			'Accessible label and tooltip for the button that removes an organisation or unit from the pinned list in the app switcher. {name} is the organisation or unit name.',
	},
});

export default messages;
